import styled, { css, keyframes } from "styled-components";

const backdropFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const backdropFadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const StyledModalBackdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 20;
  /* background: rgba(0, 0, 0, 0.5); */
  backdrop-filter: blur(8px);
  ${({ animateOut }) => css`
    animation: ${animateOut
      ? css`
          ${backdropFadeOut} 0.3s ease forwards
        `
      : css`
          ${backdropFadeIn} 0.3s ease forwards
        `};
  `}
`;

const modalFadeIn = keyframes`
  from {
    opacity: 0;
    transform:  scale(0.95);
  }
  to {
    opacity: 1;
    transform:  scale(1);
  }
`;

const modalFadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
`;

export const StyledModalContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;

  animation: ${({ animateOut }) => (animateOut ? modalFadeOut : modalFadeIn)}
    0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
`;

export const StyledModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  overflow: hidden;
  padding: 10px 10px 10px;
  box-sizing: border-box;
`;

export const StyledModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  position: relative;

  h1 {
    margin: 0;
    margin-bottom: 0;
    font-size: var(--fontSizeTitle);
    font-weight: 400;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 2px;
    color: var(--fontColor);
  }

  button:last-child {
    position: absolute;
    right: 0px;
    top: 0px;
  }
`;

export const StyledModalBody = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  font-size: 19px;
  color: var(--fontColor);
`;
